<script setup lang="ts">
import { onMounted } from 'vue';
import SOWReportingServiceProvider from '@/components/Utilization/SOWReportingServiceProvider.vue';
import TimeRatioReportingServiceProvider from '@/components/Utilization/TimeRatioReportingServiceProvider.vue';
import { useDateTime } from '@/composables';
import { useAuthStore, useUtilizationStore } from '@/store';

const authStore = useAuthStore();
const utilizationStore = useUtilizationStore();

onMounted(async () => {
  await utilizationStore.getServiceProviderTimeUsageWidgetData(Number(authStore.user?.id));
});
</script>

<template>
  <div class="w-full">
    <Loader v-if="utilizationStore.loading" class="loader loader-height" />
    <template v-else>
      <SOWReportingServiceProvider
        :sow-data="utilizationStore.serviceProviderSOWTableData"
        :filter-date="useDateTime().getMostRecentSunday()"
      />
      <TimeRatioReportingServiceProvider
        :time-ratio-data="utilizationStore.serviceProviderTimeRatioTableData"
        :filter-date="useDateTime().getMostRecentSunday()"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
.loader {
  position: relative;
  top: 50%;
  left: 50%;
  z-index: 50;
  transform: translate(-50%, -50%);
  &.loader-height {
    height: 400px;
  }
}
</style>
